import config from "config";
import { CUSTOMER_SITE_PROXY_URL } from "config/hosts";

const BASE_URL = CUSTOMER_SITE_PROXY_URL;

async function createNewChat() {
  const res = await fetch(BASE_URL + "/api/rest/talink/cube/ai/new-chat", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("currentUserToken")}`,
    },
  });
  const data = await res.json();

  if (!res.ok) {
    return Promise.reject({ status: res.status, data });
  }

  return data;
}

async function sendChatMessage(chatId, question) {
  const res = await fetch(
    BASE_URL + `/api/rest/talink/cube/ai/chat/${chatId}?question=${question}`,
    //BASE_URL + `/api/rest/talink/cube/ai/test2`,

    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("currentUserToken")}`,
      },
    }
  );

  if (!res.ok) {
    return Promise.reject({ status: res.status, data: await res.json() });
  }

  return res.body;
}

export { sendChatMessage, createNewChat };
